import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNumberFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 3.25C4.48079 3.25 3.25 4.48079 3.25 6V18C3.25 19.5192 4.48079 20.75 6 20.75H18C19.5192 20.75 20.75 19.5192 20.75 18V6C20.75 4.48079 19.5192 3.25 18 3.25H6ZM13 8.00002C13 7.69668 12.8173 7.4232 12.537 7.30711C12.2568 7.19103 11.9342 7.25519 11.7197 7.46969L9.71967 9.46969C9.42678 9.76259 9.42678 10.2375 9.71967 10.5304C10.0126 10.8232 10.4874 10.8232 10.7803 10.5304L11.5 9.81068V15.25H10.25C9.83579 15.25 9.5 15.5858 9.5 16C9.5 16.4142 9.83579 16.75 10.25 16.75H14.25C14.6642 16.75 15 16.4142 15 16C15 15.5858 14.6642 15.25 14.25 15.25H13V8.00002Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgNumberFilled);
export default ForwardRef;
